import {globals} from "../modules/globals.js";
import {playSoundEffect} from "./sounds.js";
import {
    addCustomSegmentItem, editCustomSegmentItem,
    getEditSegmentData,
    getEditSegmentsData,
    getViewSegmentsData,
    removeSegmentItem
} from "../modules/companies.js";
import {applySentenceCase, getPointsHtml, hideContent, makeGameRequest, replaceAll} from "./ui-helpers.js";
import {toTitleCase} from "../modules/helpers.js";
import {getAvailableSegmentItems} from "../modules/segments.js";
import {showGetAvailableSegmentItemsData} from "./segments.js";

let customSegmentsData = {
    addCustomSegmentChangesMade: false
};

async function loadViewSegmentsPage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getViewSegmentsData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showViewSegmentsPageData(data);
}

function showViewSegmentsPageData(data) {
    const $viewSegmentsItemsContainer = $(".view-segments-items-container");

    // Reset
    $viewSegmentsItemsContainer.html('');

    // Add segment items
    data['segmentItems'].forEach(function (item) {
        let segmentItemHtml = getViewSegmentsPageSegmentItemHtml(item);
        $('.view-segments-items-container').append(segmentItemHtml);
    });

    if (data['segmentItems'].length === 0) {
        let div =
            '<div class="view-segments-item">' +
                '<div>' +
                    '<span class="grey">No Custom Segments present</span>' +
                '</div>' +
            '</div>';
        $('.view-segments-items-container').append(div);
    }

    $("#view-segments-container").fadeIn('slow');
    $('.add-custom-segment-container').find('.back-to-view-segments-button').show();
    $viewSegmentsItemsContainer.scrollTop(0);
}

function getViewSegmentsPageSegmentItemHtml(segmentItem) {
    // Set level
    let level = '';
    switch (segmentItem['level']) {
        case 1:
            level = '<i class="fa fa-star-o margin-left-6 font-bold font-16px top-4px bronze"></i>';
            break;
        case 2:
            level = '<i class="fa fa-star-o margin-left-6 font-bold font-16px top-4px silver"></i>';
            break;
        case 3:
            level = '<i class="fa fa-star-o margin-left-6 font-bold font-16px top-4px gold-light"></i>';
            break;
    }

    let name = segmentItem['name'];
    if (name.length > 18) {
        name = name.slice(0, 18) + '.'
    }
    name = '<span>' + name + '</span>';

    let silly = '';
    if (segmentItem['silly']) {
        silly = '<div class="puke-green-dark">Silly</div>';
    }
    let consequence = '';
    if (segmentItem['consequence']) {
        let consequenceText = toTitleCase(segmentItem['consequence'].replace(/-/g, ' '));
        consequence =
            '<div class="line-height-1p4 faded-red-light padding-top-3">' +
            consequenceText +
            '</div>'
    }
    let requirement = '';
    if (segmentItem['requirement']) {
        let requirementText = toTitleCase(segmentItem['requirement'].replace(/-/g, ' '));
        requirement =
            '<div class="line-height-1p4 padding-top-1 sky-blue">' +
            requirementText +
            '</div>'
    }
    let feudOnly = '';
    if (segmentItem['feudOnly']) {
        feudOnly =
            '<div class="light-grey">' +
            'Feuds Only' +
            '</div>';
    }
    let maxParticipants = '';
    if (segmentItem['maxParticipants'] !== undefined) {
        let participantsText = 'Participant';
        if (segmentItem['maxParticipants'] !== 1) {
            participantsText = 'Participants'
        }

        let numberOfParticipants = segmentItem['maxParticipants'];
        if (segmentItem['minParticipants'] !== segmentItem['maxParticipants']) {
            numberOfParticipants = '{0}-{1}'.format(segmentItem['minParticipants'], numberOfParticipants)
        }
        if (numberOfParticipants === 0) {
            numberOfParticipants = 'No'
        }

        maxParticipants = '<div class="light-grey">' + numberOfParticipants +
            ' ' + participantsText + '</div>';
    }

    let boosts =
        '<span class="faded-red help-text" ' +
        'title="Hype Boost for the involved Feuds">' +
        '<i class="fa fa-bolt margin-right-5"></i>' + segmentItem['hypeBoost'] +
        '</span>' +
        '<span class="charisma-purple margin-left-10 help-text" ' +
        'title="Popularity Boost for the involved Participant(s)">' +
        '<i class="fa fa-angle-double-up margin-right-5"></i>' + segmentItem['popularityBoost'] +
        '</span>';

    // Get progress to next level
    let progress;
    let levelXp;
    if (segmentItem['level'] < 3) {
        levelXp = Math.pow(segmentItem['level'], 2) * 75;
        progress = (segmentItem['xp'] / levelXp) * 100;
    } else {
        levelXp = Math.pow(2, 2) * 75;
        progress = 100;
    }
    let progressHtml =
        '<div class="segment-item-progress-container display-inline-block">' +
        '<div class="progress-under help-text" title="' + segmentItem['xp'] + ' / ' + levelXp + ' XP">' +
        '<div class="progress faded-purple-background" style="width:' + progress + '%">' + '</div>' +
        '</div>' +
        '</div>';

    let stats =
        '<div><span class="segment-item-label margin-right-5 medium-grey help-text" ' +
        'title="Entertainment: Affects a Segment\'s maximum Rating and XP gain">Ent.</span>' +
        '<i class="fa fa-star dark-grey"></i>'.repeat(segmentItem['entertainment']) +
        '<i class="fa fa-star light-grey"></i>'.repeat(3 - segmentItem['entertainment']) +
        '</div>' +
        '<div><span class="segment-item-label margin-right-5 medium-grey help-text" ' +
        'title="Action: Affects a Segment\'s maximum Rating and XP gain">Act.</span>' +
        '<i class="fa fa-star dark-grey"></i>'.repeat(segmentItem['action']) +
        '<i class="fa fa-star light-grey"></i>'.repeat(3 - segmentItem['action']) +
        '</div>' +
        '<div><span class="segment-item-label margin-right-5 medium-grey help-text" ' +
        'title="Difficulty: Used alongside the Charisma of the Participants to get the Segment\'s ' +
        'Effectiveness and Rating">Diff.</span>' +
        '<i class="fa fa-star dark-grey"></i>'.repeat(segmentItem['difficulty']) +
        '<i class="fa fa-star light-grey"></i>'.repeat(3 - segmentItem['difficulty']) +
        '</div>';

    let info =
        '<div>' +
        maxParticipants + feudOnly + silly + requirement + consequence +
        '</div>';

    return '<div class="view-segments-item">' +

        '<div class="margin-bottom-6">' +
            '<div class="column-left">' +
                name +
            '</div>' +
            '<div class="column-right segment-right-header-container">' +
                '<div class="column-left">' +
                progressHtml + level +
                '</div>' +
                '<div class="column-right text-right ">' +
                boosts +
                '</div>' +
                '<div class="clear"></div>' +
            '</div>' +
            '<div class="clear"></div>' +
        '</div>' +

        '<div class="column-left">' +
        stats +
        '</div>' +
        '<div class="column-right margin-top-1">' +
        info +
        '</div>' +
        '<div class="clear"></div>' +
        '</div>';
}

async function loadEditSegmentsPage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getEditSegmentsData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showEditSegmentsPageData(data);
}

function showEditSegmentsPageData(data) {
    let $select = $('.edit-custom-segment-container .select-custom-segment');
    $select.html('');
    $.each(data, function () {
        $select.append($("<option />").val(this).text(this));
    });
    $(".edit-custom-segment-container").fadeIn('slow').removeClass('display-none');
}

async function getRemoveSegmentRequest(name) {

    if (globals.requestRunning) {
        return;
    }
    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await removeSegmentItem(name);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showRemoveSegmentData(data);
}

function showRemoveSegmentData(data) {
    if (!data['error']) {
        playSoundEffect('success');
        let html = '<span class="faded-purple">' + data['name'] + '</span> removed';
        notie.alert({type: 4, text: html});

        // Select next custom segment
        let selected = $(".edit-custom-segment-container .select-custom-segment").find(":selected");
        selected.next().prop('selected', true);
        selected.remove();
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'not-found') {
            notie.alert({type: 3, text: "The Segment could not be found. Please try again."});
        }
        else if (data['error'] === 'not-custom') {
            notie.alert({type: 3, text: "Only custom Segment Items can be removed."});
        }
    }
}

async function loadEditSegmentPage(name) {

    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getEditSegmentData(name);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showEditSegmentPageData(data);
}

function showEditSegmentPageData(data) {
    if (!data['error']) {
        playSoundEffect('success');
        const $addCustomSegmentContainer = $('.add-custom-segment-container');
        const $addCustomSegmentStartText = $('.add-custom-segment-start-text');
        const $addCustomSegmentActionText = $('.add-custom-segment-action-text');
        const $addCustomSegmentTagStartText = $('.add-custom-segment-tag-start-text');
        const $addCustomSegmentTagActionText = $('.add-custom-segment-tag-action-text');

        // Show 'add custom segment' container
        hideContent($());
        $addCustomSegmentContainer.removeClass('scroll margin-top-20').fadeIn('slow');
        $(".add-custom-segment-template-button").removeClass('selected');

        // Reset
        $('.add-custom-segment-more-options').hide();
        let customSegmentMoreOptionsButton = $(".add-custom-segment-more-options-button");
        customSegmentMoreOptionsButton.find('i').removeClass('fa-angle-up').addClass('fa-angle-down');
        customSegmentMoreOptionsButton.find('span').text('Show Details');
        $('.import-community-segment-input').val('');

         $('.add-custom-segment-community-segments-container').hide();
        let customSegmentCommunitySegmentsButton = $(".add-custom-segment-show-community-segments-button");
        customSegmentCommunitySegmentsButton.find('i').removeClass('fa-angle-up').addClass('fa-angle-down');
        customSegmentCommunitySegmentsButton.find('span').text('Show Community Segments');

        $('.add-custom-segment-help-text-container').hide();
        let customSegmentHelpButton = $(".add-custom-segment-help-button");
        customSegmentHelpButton.find('i').removeClass('fa-angle-up').addClass('fa-angle-down');
        customSegmentHelpButton.find('span').text('Show How It Works');

        // Hide save options
        $('.add-custom-segment-save-to-game-container').hide();
        $('.add-custom-segment-save-to-community-container').hide();
        $('.add-custom-segment-cost').text(0);

        // Show edit info
        $('.edit-custom-segment-button').show();
        $('.add-custom-segment-button').hide();
        $('.add-custom-segment-label').text('Edit Custom Segment');

        // Remove extra action text inputs
        $addCustomSegmentActionText.not(':first').remove();
        $addCustomSegmentTagActionText.not(':first').remove();

        // Reset texts
        $addCustomSegmentStartText.val('');
        $addCustomSegmentActionText.val('');
        $addCustomSegmentTagStartText.val('');
        $addCustomSegmentTagActionText.val('');

        // Add segment data
        $addCustomSegmentContainer.data('name', data['name']);
        $('.add-custom-segment-name-input').val(data['name']);
        $('.add-custom-segment-participants-input').val(data['participants']);
        $addCustomSegmentStartText.val(data['startText']);

        // Add action text
        $addCustomSegmentActionText.val(data['actionText'][0]);

        // Multiple action texts
        let actionTextHtml = '<textarea class="add-custom-segment-action-text' +
            ' styled-input margin-top-7" autocomplete="off" maxlength="200"></textarea>';
        data['actionText'].forEach(function(actionText, i) {
            if (i > 0) {
                $('.add-custom-segment-action-text').last().after(actionTextHtml);
                $('.add-custom-segment-action-text').eq(i).val(actionText);
            }
        });

        if (data['startTagText']) {
            $addCustomSegmentTagStartText.val(data['startTagText']);
        }

        // Add tag action text
        if (data['actionTagText']) {
            $addCustomSegmentTagActionText.val(data['actionTagText'][0]);

            // Multiple tag action texts
            let actionTextHtml = '<textarea class="add-custom-segment-tag-action-text' +
                ' styled-input margin-top-7" autocomplete="off" maxlength="200"></textarea>';
            data['actionTagText'].forEach(function (actionText, i) {
                if (i > 0) {
                    $('.add-custom-segment-tag-action-text').last().after(actionTextHtml);
                    $('.add-custom-segment-tag-action-text').eq(i).val(actionText);
                }
            });
        }

        let chooseWinnerValue = (data['chooseWinner']) ? 'yes' : 'no';
        $('input[name="add-custom-segment-choose-winner-option"][value="' + chooseWinnerValue + '"]')
            .prop('checked', true);
        let feudOnlyValue = (data['feudOnly']) ? 'yes' : 'no';
        $('input[name="add-custom-segment-feud-only-option"][value="' + feudOnlyValue + '"]')
            .prop('checked', true);
        let sillyValue = (data['silly']) ? 'yes' : 'no';
        $('input[name="add-custom-segment-silly-option"][value="' + sillyValue + '"]')
            .prop('checked', true);

        // Run preview
        $('.add-custom-segment-preview-singles-button').trigger('click');

        // Confirm before changes
        customSegmentsData.addCustomSegmentChangesMade = true;
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'not-found') {
            notie.alert({type: 3, text: 'That Segment could not be found. Please try again.'});
        }
        if (data['error'] === 'production-segment') {
            notie.alert({type: 3, text: 'Production Segments cannot be edited'});
        }
    }
}

async function getAddCustomSegmentRequest() {

    if (globals.requestRunning) {
        return;
    }

    // Disabled if add custom segment disabled
    if ($('.add-custom-segment-container').hasClass('disabled')) {
        return false;
    }

    // Get name, participants
    let name = $('.add-custom-segment-name-input').val();
    let numberOfParticipants = $('.add-custom-segment-participants-input').val();

    // Get start and action texts
    let startText = $('.add-custom-segment-start-text').val();
    let actionTexts = $('.add-custom-segment-action-text').map(function (i, x) {
        if (!!x.value) {
            return x.value;
        }
    }).toArray();
    let tagStartText = $('.add-custom-segment-tag-start-text').val();
    let tagActionTexts = $('.add-custom-segment-tag-action-text').map(function (i, x) {
        if (!!x.value) {
            return x.value;
        }
    }).toArray();

    // Validate inputs
    if (!name) {
        notie.alert({type: 3, text: "Enter a name for the Segment"});
        return false;
    }
    if (!startText) {
        notie.alert({type: 3, text: "Enter a Start Text for the Segment"});
        return false;
    }
    if (actionTexts.length <= 0) {
        notie.alert({type: 3, text: "Enter an Action Text for the Segment"});
        return false;
    }
    if (!numberOfParticipants) {
        notie.alert({type: 3, text: "Enter the number of participants for the Segment"});
        return false;
    }

    // Get options
    let saveToGame = $('input[name="add-custom-segment-save-to-game-option"]:checked').val() === 'yes';
    let saveToCommunity = $('input[name="add-custom-segment-save-to-community-option"]:checked').val() === 'yes';
    let chooseWinner = $('input[name="add-custom-segment-choose-winner-option"]:checked').val() === 'yes';
    let feudOnly = $('input[name="add-custom-segment-feud-only-option"]:checked').val() === 'yes';
    let silly = $('input[name="add-custom-segment-silly-option"]:checked').val() === 'yes';
    numberOfParticipants = parseInt(numberOfParticipants);

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await addCustomSegmentItem(name, numberOfParticipants, startText, actionTexts, tagStartText,
        tagActionTexts, saveToGame, saveToCommunity, chooseWinner, feudOnly, silly);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    await showAddCustomSegmentData(data);
}

async function showAddCustomSegmentData(data) {
    if (!data['error']) {
        playSoundEffect('success');
        notie.alert({
            type: 4,
            text: '<span class="faded-purple">' + data['name'] + '</span> added!',
            stay: true
        });

        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        let bookCustomSegmentButton = $('.add-custom-segment-segments-menu-button:visible');
        if (bookCustomSegmentButton.length > 0) {

            let scrollFunction = function () {
                // Scroll to this segment item
                let $container = $('#segment-items-container'),
                    $scrollTo = $('.segment-item-container').filter(function () {
                        return $(this).find('.segment-item-name').text() === data['name']
                    });
                $container.scrollTop(
                    $scrollTo.offset().top - $container.offset().top + $container.scrollTop()
                );
                // Highlight segment item
                setTimeout(function () {
                    $scrollTo.addClass("flash-border-red");
                }, 0);
                setTimeout(function () {
                    $scrollTo.removeClass("flash-border-red");
                }, 1500);
                $('.add-custom-segment-container').hide();
                $('.add-custom-segment-segments-menu-button').removeClass('selected');
            };

            // Reload segment items, pass scrollFunction as callback
            await makeGameRequest(getAvailableSegmentItems, {}, showGetAvailableSegmentItemsData,
                {callbackFunction: scrollFunction}, false, true);
        }
        else {
            // Go back to view segments
            setTimeout(function () {
                $('#view-segments-menu-button').trigger('click');
            }, 800);
        }
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'paid-only') {
            notie.alert({
                type: 3, text: 'Custom Segments can only be added in JoW Paid'
            });
        }
        if (data['error'] === 'not-enough-points') {
            notie.alert({
                type: 3, text: 'You do not have enough Creative Points to add a Custom Segment'
            });
        }
        if (data['error'] === 'already-exists') {
            notie.alert({
                type: 3, text: 'A Segment with that name already exists'
            });
        }
    }
}

async function getEditCustomSegmentRequest() {

    if (globals.requestRunning) {
        return;
    }

    // Get name, participants
    let previousName = $('.add-custom-segment-container').data('name');
    let name = $('.add-custom-segment-name-input').val();
    let numberOfParticipants = $('.add-custom-segment-participants-input').val();

    // Get start and action texts
    let startText = $('.add-custom-segment-start-text').val();
    let actionTexts = $('.add-custom-segment-action-text').map(function (i, x) {
        if (!!x.value) {
            return x.value;
        }
    }).toArray();
    let tagStartText = $('.add-custom-segment-tag-start-text').val();
    let tagActionTexts = $('.add-custom-segment-tag-action-text').map(function (i, x) {
        if (!!x.value) {
            return x.value;
        }
    }).toArray();

    // Validate inputs
    if (!name) {
        notie.alert({type: 3, text: "Enter a name for the Segment"});
        return false;
    }
    if (!startText) {
        notie.alert({type: 3, text: "Enter a Start Text for the Segment"});
        return false;
    }
    if (actionTexts.length <= 0) {
        notie.alert({type: 3, text: "Enter an Action Text for the Segment"});
        return false;
    }

    if (!numberOfParticipants) {
        notie.alert({type: 3, text: "Enter the number of participants for the Segment"});
        return false;
    }

    // Get options
    let chooseWinner = $('input[name="add-custom-segment-choose-winner-option"]:checked').val() === 'yes';
    let feudOnly = $('input[name="add-custom-segment-feud-only-option"]:checked').val() === 'yes';
    let silly = $('input[name="add-custom-segment-silly-option"]:checked').val() === 'yes';
    numberOfParticipants = parseInt(numberOfParticipants);

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;

    let data = await editCustomSegmentItem(name, previousName, numberOfParticipants, startText, actionTexts,
        tagStartText, tagActionTexts, chooseWinner, feudOnly, silly);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showEditCustomSegmentData(data);
}

function showEditCustomSegmentData(data) {
    if (!data['error']) {
        playSoundEffect('success');
        notie.alert({
            type: 4,
            text: '<span class="faded-purple">' + data['name'] + '</span> edited',
            stay: true
        });

        // Go back to view segments
        setTimeout(function () {
            $('#view-segments-menu-button').trigger('click')
        }, 600);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'paid-only') {
            notie.alert({
                type: 3, text: 'Custom Segments can only be edited in JoW Paid'
            });
        }
        if (data['error'] === 'not-found') {
            notie.alert({
                type: 3, text: 'That Segment could not be found. Please try again.'
            });
        }
        if (data['error'] === 'already-exists') {
            notie.alert({
                type: 3, text: 'A Segment with that name already exists'
            });
        }
    }
}

function loadCustomSegmentTemplate(el) {
    $('.add-custom-segment-template-button').removeClass('selected');
    el.addClass('selected');
    let val = el.text().trim();
    const $addCustomSegmentStartText = $('.add-custom-segment-start-text');
    let $addCustomSegmentActionText = $('.add-custom-segment-action-text');
    const $addCustomSegmentTagStartText = $('.add-custom-segment-tag-start-text');
    const $addCustomSegmentTagActionText = $('.add-custom-segment-tag-action-text');

    // Reset texts
    $addCustomSegmentStartText.val('');
    $addCustomSegmentActionText.val('');
    $addCustomSegmentTagStartText.val('');
    $addCustomSegmentTagActionText.val('');

    // Remove extra action text inputs
    $addCustomSegmentActionText.not(':first').remove();
    $addCustomSegmentTagActionText.not(':first').remove();

    // Set winner and silly to 'no'
    $('input[name="add-custom-segment-choose-winner-option"][value="no"]').prop('checked', true);
    $('input[name="add-custom-segment-silly-option"][value="no"]').prop('checked', true);

    // Deselect community segment result
    $('.community-segments-box').find('.community-segments-search-result-item.selected').removeClass('selected');

    if (val === 'Promo') {

        // Name, participants and texts
        $('.add-custom-segment-name-input').val('Promo');
        $('.add-custom-segment-participants-input').val(1);
        $addCustomSegmentStartText.val('{name1} comes out to the ring ...');
        $addCustomSegmentActionText.eq(0).val('{name1} talked about how much better {pronoun1} is than every person sitting the crowd.');

        // Feud and save options
        $('input[name="add-custom-segment-feud-only-option"][value="no"]').prop('checked', true);
        $('input[name="add-custom-segment-save-to-community-option"][value="yes"]').prop('checked', true);
        $('input[name="add-custom-segment-save-to-game-option"][value="yes"]').prop('checked', true).trigger('change');

    }
    else if (val === 'Feud') {

        $('.add-custom-segment-name-input').val('Confrontation');
        $('.add-custom-segment-participants-input').val(2);
        $addCustomSegmentStartText.val('We\'re going backstage for a confrontation between {name1} and {name2} ...');
        $addCustomSegmentActionText.eq(0).val('{name1} goes over {possessive1} accomplishments and {name2} does the same. They come face to face and stare each other down.');

        $('input[name="add-custom-segment-feud-only-option"][value="yes"]').prop('checked', true);
        $('input[name="add-custom-segment-save-to-community-option"][value="yes"]').prop('checked', true);
        $('input[name="add-custom-segment-save-to-game-option"][value="yes"]').prop('checked', true).trigger('change');

    }
    else if (val === 'Basic') {

        $('.add-custom-segment-name-input').val('Opening Segment');
        $('.add-custom-segment-participants-input').val(0);
        $addCustomSegmentStartText.val('The show opens with fireworks ...');
        $addCustomSegmentActionText.eq(0).val('The announcers welcome the fans to the show!');

        $('input[name="add-custom-segment-feud-only-option"][value="no"]').prop('checked', true);
        $('input[name="add-custom-segment-save-to-community-option"][value="yes"]').prop('checked', true);
        $('input[name="add-custom-segment-save-to-game-option"][value="no"]').prop('checked', true).trigger('change');

    }
    else if (val === 'Singles & Tag') {

        $('.add-custom-segment-name-input').val('Reclaim Honor');
        $('.add-custom-segment-participants-input').val(1);
        $addCustomSegmentStartText.val('{name1} is out in the ring with a mic in hand ...');
        $addCustomSegmentActionText.eq(0).val('{name1} is insistent on reclaiming lost honor and strives to work hard for it. The fans start to cheer {objective1}.');
        $addCustomSegmentTagStartText.val('{name1} are out in the ring with mics in hand ...');
        $addCustomSegmentTagActionText.eq(0).val('{name1} are insistent on reclaiming lost honor and strive to work hard for it. The fans start to cheer {objective1}.');

        $('input[name="add-custom-segment-feud-only-option"][value="no"]').prop('checked', true);
        $('input[name="add-custom-segment-save-to-community-option"][value="yes"]').prop('checked', true);
        $('input[name="add-custom-segment-save-to-game-option"][value="yes"]').prop('checked', true).trigger('change');

    }
    else if (val === 'Select Winner') {

        $('.add-custom-segment-name-input').val('Windshield Destruction');
        $('.add-custom-segment-participants-input').val(2);
        $addCustomSegmentStartText.val('The camera crew is in the parking lot ... ');
        $addCustomSegmentActionText.eq(0).val('{name1} appeared, standing in front of {name2}\'s car, before destroying the windshield with a baseball bat!');

        $('input[name="add-custom-segment-feud-only-option"][value="no"]').prop('checked', true);
        $('input[name="add-custom-segment-save-to-community-option"][value="yes"]').prop('checked', true);
        $('input[name="add-custom-segment-save-to-game-option"][value="yes"]').prop('checked', true).trigger('change');
        $('input[name="add-custom-segment-choose-winner-option"][value="yes"]').prop('checked', true);

    }
    else if (val === 'Action Choices') {

        $('.add-custom-segment-name-input').val('Heel Interview');
        $('.add-custom-segment-participants-input').val(1);
        $addCustomSegmentStartText.val('Our interviewer is backstage with {name1} ...');

        // Add 5 action texts
        let actionTextHtml = '<textarea class="add-custom-segment-action-text styled-input margin-top-7" ' +
            'autocomplete="off" maxlength="200"></textarea>';
        $addCustomSegmentActionText.last().after(actionTextHtml + actionTextHtml + actionTextHtml + actionTextHtml);

        // Add values to action texts
        $addCustomSegmentActionText = $('.add-custom-segment-action-text');
        $addCustomSegmentActionText.eq(0).val('{name1} talks about being the best in the business.');
        $addCustomSegmentActionText.eq(1).val('{name1} comes on to the interviewer.');
        $addCustomSegmentActionText.eq(2).val('{name1} makes fun of the crowd for being poor.');
        $addCustomSegmentActionText.eq(3).val('{name1} insults the interviewer\'s looks.');
        $addCustomSegmentActionText.eq(4).val('{name1} berates the wrestlers in the locker room.');

        $('input[name="add-custom-segment-feud-only-option"][value="no"]').prop('checked', true);
        $('input[name="add-custom-segment-save-to-community-option"][value="yes"]').prop('checked', true);
        $('input[name="add-custom-segment-save-to-game-option"][value="yes"]').prop('checked', true).trigger('change');
    }

    // Show preview
    if (val === 'Singles & Tag') {
        $('.add-custom-segment-preview-tag-button').trigger('click');
    }
    else {
        $('.add-custom-segment-preview-singles-button').trigger('click');
    }

    // Allow changes without confirm
    customSegmentsData.addCustomSegmentChangesMade = false;
}

function runCustomSegmentPreviewAnimation(name, startText, actionText, participants, chooseWinner,
                                          nameElement, startTextElement, actionTextElement) {

    // Reset
    startTextElement.text('').addClass('medium-dark-grey').removeClass('light-grey');
    actionTextElement.text('');
    nameElement.text('');

    // Generate text
    startText = parseCustomSegmentText(startText, participants);

    // Show action text if not selecting winner or less than 2 participants in segment
    if (!chooseWinner || participants.length < 2) {
        actionText = parseCustomSegmentText(actionText, participants);
        actionTextElement.html(actionText).hide().fadeIn(500);
    }
    else {
        // Show participants
        let participantsDisplay;
        let participantsHtml = [];
        participants.forEach(function (participant) {
            participantsHtml.push('<div class="match-wrestler-container">' +
                '<button class="match-wrestler match-span">' + participant['name'] + '</button></div>');
        });
        if (participants.length > 4) {
            participantsDisplay = participantsHtml.join('');
        }
        else {
            participantsDisplay = participantsHtml.join('<span class="match-span dark-grey"></span>');
        }

        actionTextElement.html(participantsDisplay).hide().fadeIn(500);
    }

    nameElement.text(name);
    startTextElement.html(startText).hide().fadeIn(500);
    startTextElement.removeClass('medium-dark-grey').addClass('light-grey');
    return true;
}

function parseCustomSegmentText(text, participants) {

    function getPronoun(type) {
        if (type === 'he') {
            return 'he'
        }
        if (type === 'she') {
            return 'she'
        }
        if (type === 'tag') {
            return 'they'
        }
    }

    function getObjectivePronoun(type) {
        if (type === 'he') {
            return 'him'
        }
        if (type === 'she') {
            return 'her'
        }
        if (type === 'tag') {
            return 'them'
        }
    }

    function getPossessivePronoun(type) {
        if (type === 'he') {
            return 'his'
        }
        if (type === 'she') {
            return 'her'
        }
        if (type === 'tag') {
            return 'their'
        }
    }

    // Parse keywords for participants
    for (let i = 0; i < participants.length; i++) {
        text = replaceAll(text, '{name{0}}'.format(i + 1), '<span class="faded-blue">' + participants[i].name + '</span>');
        text = replaceAll(text, '{pronoun{0}}'.format(i + 1), getPronoun(participants[i].type));
        text = replaceAll(text, '{objective{0}}'.format(i + 1), getObjectivePronoun(participants[i].type));
        text = replaceAll(text, '{possessive{0}}'.format(i + 1), getPossessivePronoun(participants[i].type));
    }

    return applySentenceCase(text);
}

export {loadViewSegmentsPage, loadEditSegmentsPage, loadCustomSegmentTemplate, loadEditSegmentPage,
    getRemoveSegmentRequest, getEditCustomSegmentRequest, getAddCustomSegmentRequest, runCustomSegmentPreviewAnimation,
    parseCustomSegmentText, customSegmentsData}